<div class="comparer-inner">
    <p class="title font-bold mb-1">{{ 'IRONSIDE.comparator.COMPARATOR' | translate }}</p>
    <ul class="">
        <ng-container *ngFor="let product of products">
            <li class="d-flex justify-content-between align-items-center gap-2">
                <div class="wrap-img">
                    <img
                        *ngIf="product?.image"
                        [src]="product?.image ?? 'src-ironside/assets/images/image-default.jpg'"
                        alt=""
                    />
                    <img *ngIf="!product?.image" src="src-ironside/assets/no_image.jpg" alt="" />
                </div>
                <a [routerLink]="'/product/detail/' + product?.referenceProduct">{{
                    product?.title
                }}</a>
                <button class="btn-delete" (click)="deleteProduct(product?.id)">
                    <img src="src-ironside/assets/icons/trash.svg" alt="" />
                </button>
            </li>
        </ng-container>

        <!-- skeleton start -->
        <ng-container *ngIf="!products">
            <p-skeleton height="53px" styleClass="mb-2" *ngFor="let _ of [1, 2]"></p-skeleton>
        </ng-container>
        <ng-container *ngIf="products?.length === 0">
            <span>{{ 'IRONSIDE.comparator.NO_ITEMS' | translate }}</span>
        </ng-container>
        <!-- skeleton end -->
    </ul>
    <a class="btn-common btn-comparer" [routerLink]="'/product-comparator'">
        <img class="non-hover" src="src-ironside/assets/icons/comparator_white.svg" alt="" />
        <img class="hover" src="src-ironside/assets/icons/comparator.png" alt="" />
        {{ 'IRONSIDE.comparator.COMPARE' | translate }}
    </a>
</div>
